import { render, staticRenderFns } from "./BaseEmptyState.vue?vue&type=template&id=01339c5e&scoped=true&"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmptyState.vue?vue&type=style&index=0&id=01339c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01339c5e",
  null
  
)

export default component.exports